import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProfileSliceState } from "../../types/store";
import { UserAuthInfo } from "../../types/auth";
import { Membership, UserProfile } from "../../types/profile";
import { StripeCustomer, StripeCustomerBillingData, StripeCustomerBillingDataPayload } from "../../types/stripe";

const initialState: ProfileSliceState = {
  checked: false,
  userProfile: null,
  loadingProfile: false,
  loadProfileError: null,
  updatingProfile: false,
  displayName: '',
  promoCode: '',
  paymentMethod:null
};

export const PROFILE_SLICE = 'profile' as const;

export const profileSlice = createSlice({
  name: PROFILE_SLICE,
  initialState: initialState,
  reducers: {
    loadProfile: (
      state: ProfileSliceState,
      { payload: _ }: PayloadAction<UserAuthInfo | null> 
    ) => {
      state.userProfile = null;
      state.loadProfileError = null;
      state.loadingProfile = true;
    },
    loadPaymentMethod: (
      state: ProfileSliceState,
      { payload: method }: PayloadAction<any>
    ) => {
      state.paymentMethod = method;
    },
    loadProfileSuccess: (
      state: ProfileSliceState,
      { payload: userProfile }: PayloadAction<UserProfile | null>
    ) => {
      state.userProfile = userProfile;
      state.loadProfileError = null;
      state.loadingProfile = false;
      state.checked = true;
      state.displayName = '';
      state.promoCode = '';
    },
    loadProfileError: (
      state: ProfileSliceState,
      { payload: error }: PayloadAction<any>
    ) => {
      state.userProfile = null;
      state.loadProfileError = error;
      state.loadingProfile = false;
      state.checked = true;
    },
    updateStripeCustomer: (
      state: ProfileSliceState,
      { payload: _ }: PayloadAction<StripeCustomerBillingData>
    ) => {
      state.updatingProfile = true;
    },
    updateStripeCustomerData: (
      state: ProfileSliceState,
      { payload: _ }: PayloadAction<StripeCustomer>
    ) => {
      if(state.userProfile){
        state.userProfile.stripeCustomer = _;
      }
    },
    updateStripeCustomerSuccess: (
      state: ProfileSliceState,
      { payload: stripeCustomer }: PayloadAction<StripeCustomer>
    ) => {
      state.updatingProfile = false;
      if (state.userProfile) {
        state.userProfile.stripeCustomer = stripeCustomer;
      }
    },
    updateStripeCustomerError: (
      state: ProfileSliceState,
      { payload: error }: PayloadAction<any>
    ) => {
      state.updatingProfile = false;
    },
    updateDisplayName: (
      state: ProfileSliceState,
      { payload: name }: PayloadAction<string>
    ) => {
      state.displayName = name;
    },
    updatePromoCode: (
      state: ProfileSliceState,
      { payload: code }: PayloadAction<string>
    ) => {
      state.promoCode = code;
    },



    

    // FIXME: deprecated
    updateMembershipData: (
      state: ProfileSliceState,
      { payload: membershipData }: PayloadAction<Membership>
    ) => {
      if (state.userProfile) {
        state.userProfile.membership = membershipData;
      }
    }
  }
});

export const {
  loadProfile,
  loadProfileError,
  loadProfileSuccess,
  updateMembershipData,
  updateStripeCustomer,
  updateStripeCustomerError,
  updateStripeCustomerSuccess,
  updateDisplayName,
  updatePromoCode,
  updateStripeCustomerData,
  loadPaymentMethod
} = profileSlice.actions;

export default profileSlice.reducer;